import type { GalleryModel } from '@/models/gallery.model'

/**
 * Returns a hardcoded mock {@link GalleryModel} with varied files covering
 * multiple content types (image, video, audio, PDF, spreadsheet, presentation,
 * document, code, and archive), including playable and unsupported media cases.
 *
 * Files 1–3 include `thumbnailUrl` values (picsum placeholders).
 *
 * @returns A fully-populated mock gallery.
 */
export function getMockGallery(): GalleryModel {
  return {
    id: 'mock-gallery-01',
    title: 'Project Assets — Q2 2026',
    senderName: 'Alice Dupont',
    expiresAt: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000), // 7 days from now
    files: [
      {
        id: 'file-01',
        name: 'hero-banner.jpg',
        size: 2_457_600,
        contentUrl: 'https://picsum.photos/id/10/1200/600',
        thumbnailUrl: 'https://picsum.photos/id/10/200/200',
        contentType: 'image/jpeg',
      },
      {
        id: 'file-02',
        name: 'product-demo.mp4',
        size: 52_428_800,
        contentUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
        thumbnailUrl: 'https://picsum.photos/id/20/200/200',
        contentType: 'video/mp4',
      },
      {
        id: 'file-03',
        name: 'logo.png',
        size: 184_320,
        contentUrl: 'https://picsum.photos/id/30/600/600',
        thumbnailUrl: 'https://picsum.photos/id/30/200/200',
        contentType: 'image/png',
      },
      {
        id: 'file-04',
        name: 'Q2-report.pdf',
        size: 3_145_728,
        contentUrl: 'https://example.com/files/q2-report.pdf',
        thumbnailUrl: '',
        contentType: 'application/pdf',
      },
      {
        id: 'file-05',
        name: 'budget-2026.xlsx',
        size: 512_000,
        contentUrl: 'https://example.com/files/budget-2026.xlsx',
        thumbnailUrl: '',
        contentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      {
        id: 'file-06',
        name: 'roadmap-deck.pptx',
        size: 8_388_608,
        contentUrl: 'https://example.com/files/roadmap-deck.pptx',
        thumbnailUrl: '',
        contentType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      },
      {
        id: 'file-07',
        name: 'meeting-notes.docx',
        size: 102_400,
        contentUrl: 'https://example.com/files/meeting-notes.docx',
        thumbnailUrl: '',
        contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      },
      {
        id: 'file-08',
        name: 'config.json',
        size: 4_096,
        contentUrl: 'https://example.com/files/config.json',
        thumbnailUrl: '',
        contentType: 'application/json',
      },
      {
        id: 'file-10',
        name: 'assets-bundle.zip',
        size: 20_971_520,
        contentUrl: 'https://example.com/files/assets-bundle.zip',
        thumbnailUrl: '',
        contentType: 'application/zip',
      },
      {
        id: 'file-11',
        name: 'high-efficiency-photo.heic',
        size: 184_320,
        contentUrl: 'https://example.com/files/high-efficiency-photo.heic',
        thumbnailUrl: 'https://example.com/files/high-efficiency-photo.heic',
        contentType: 'image/heic',
      },
      {
        id: 'file-12',
        name: 'unsupported-video.mp4',
        size: 41_943_040,
        contentUrl: 'https://example.com/files/unsupported-video.mp4',
        thumbnailUrl: '',
        contentType: 'video/mp4',
      },
      {
        id: 'file-13',
        name: 'voice-message.mp3',
        size: 1_024_000,
        contentUrl: 'https://www.w3schools.com/html/horse.mp3',
        thumbnailUrl: '',
        contentType: 'audio/mpeg',
      },
      {
        id: 'file-14',
        name: 'unsupported-voice-message.mp3',
        size: 1_024_000,
        contentUrl: 'https://example.com/files/unsupported-voice-message.mp3',
        thumbnailUrl: '',
        contentType: 'audio/mpeg',
      },
      {
        id: 'file-15',
        name: 'mislabeled-video.mp4',
        size: 52_428_800,
        contentUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
        thumbnailUrl: '',
        contentType: 'application/mp4',
      },
      {
        id: 'file-16',
        name: 'clip.mov',
        size: 52_428_800,
        contentUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
        thumbnailUrl: '',
        contentType: 'video/quicktime',
      },
    ],
  }
}
